import { combineReducers } from 'redux'
import { createForms } from 'react-redux-form/immutable'
import { routerReducer as routing } from 'react-router-redux'

import app from 'containers/App/reducer'
import { passwordState } from 'containers/Account/reducer'
import notification from 'components/Notification/reducer'
import auth, { loginState } from 'containers/Auth/reducer'
import admin, { changeSemState } from 'containers/Admin/reducer'
import grade, { classState } from 'containers/Grades/reducer'

export default combineReducers({
  // main reducers
  app,
  admin,
  auth,
  notification,
  grade,

  // react-redux-form
  ...createForms({
    loginState,
    passwordState,
    changeSemState,
    classState,
  }),

  // other
  routing,
})



// WEBPACK FOOTER //
// ./src/reducers.js